import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = ["aria-label"]
const _hoisted_2 = { class: "frames-head" }
const _hoisted_3 = { class: "frames-copy" }
const _hoisted_4 = { class: "kicker" }
const _hoisted_5 = { class: "grid home-stagger" }
const _hoisted_6 = { class: "photo" }
const _hoisted_7 = ["src", "alt"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_home_reveal = _resolveDirective("home-reveal")!

  return _withDirectives((_openBlock(), _createElementBlock("section", {
    id: "home-frames",
    class: "frames",
    "aria-label": _ctx.t('homeFramesTitle')
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("p", _hoisted_4, _toDisplayString(_ctx.t('instantFramedPhotos')), 1),
        _createElementVNode("h2", null, _toDisplayString(_ctx.t('homeFramesTitle')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.t('homeFramesText')), 1)
      ]),
      _createVNode(_component_router_link, {
        class: "more",
        to: "/signUp"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('seeMore')), 1)
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_5, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.frames, (frame) => {
        return (_openBlock(), _createElementBlock("figure", {
          key: frame.titleKey
        }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("img", {
              src: frame.src,
              alt: _ctx.t(frame.titleKey)
            }, null, 8, _hoisted_7)
          ]),
          _createElementVNode("figcaption", null, _toDisplayString(_ctx.t(frame.titleKey)), 1)
        ]))
      }), 128))
    ])
  ], 8, _hoisted_1)), [
    [_directive_home_reveal]
  ])
}